var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "currentColor",
        viewBox: "0 0 256 256",
      },
    },
    [
      _c("rect", { attrs: { width: "256", height: "256", fill: "none" } }),
      _c("circle", { attrs: { cx: "92", cy: "128", r: "12" } }),
      _c("circle", { attrs: { cx: "164", cy: "128", r: "12" } }),
      _c("path", {
        attrs: {
          d: "M156,168a53,53,0,0,1-56,0",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("circle", {
        attrs: {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
      _c("path", {
        attrs: {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }